module.exports = ["たった今","%s 秒前","%s 分前","%s 時間前","%s 日前","%s 週間前","%s ヶ月前","%s 年前"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/ja-JP.json
// module id = kAj5
// module chunks = 1